/**
 * Priority level assigned to a request.
 */
export const RequestPriorityEnum = {
  HIGHEST: 'HIGHEST',
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW',
  LOWEST: 'LOWEST',
} as const

export type RequestPriorityEnum = (typeof RequestPriorityEnum)[keyof typeof RequestPriorityEnum]
